import { Reducer } from "redux";
import { ToastMessage } from "primereact/toast";
import type { UserToastMessage } from '../../types/models/error/UserToastMessage';

import { ValidationResult } from "../../types/models/error/ValidationResult";


export interface AlertState {
  messages?: UserToastMessage[];
}

export enum AlertActionType {
  success = "alert_success",
  error = `alert_error`,
  info = "alert_info",
  warn = "alert_warning",
}
const defaultMessage: ToastMessage = {life: 5000, closable: true, sticky: false};

interface AlertAction {
  type: AlertActionType;
  messages: UserToastMessage[];
  [key: string]: unknown;
}

export const alertSuccess: (message?: ToastMessage) => AlertAction = (message?: ToastMessage) => (
{
    type: AlertActionType.success,
    messages: [{summary: `Успешно`, detail: `Сохранено`, ...message}]
})
export const alertInfo: (message: ToastMessage) => AlertAction = (message: ToastMessage) => (
{
    type: AlertActionType.info,
    messages: [message]
})
export const alertWarn: (message: ToastMessage) => AlertAction = (message: ToastMessage) => (
{
    type: AlertActionType.warn,
    messages: [{summary: `Предупреждение`, ...message}]
})
export const alertErrors: (messages: ToastMessage[]) => AlertAction = (messages: ToastMessage[]) => (
{
    type: AlertActionType.error,
    messages: messages
})
export const alertError: (message?: ToastMessage) => AlertAction = (message?: ToastMessage) => 
  alertErrors([{summary: `Ошибка`, ...message}])

export const alertValidationResult: (result: ValidationResult) => AlertAction = (result: ValidationResult) => ({
  type: result.isValid ? AlertActionType.info : AlertActionType.error,
  messages: result.Errors.map(e => {return {summary: e.Field, detail: e.Message}})
})

export const alertNotAuthorized: (statusText: string) => AlertAction = (statusText: string) => ( 
  alertWarn({summary: `Авторизация`, detail: statusText}))
export const alertServerError: (message: string) => AlertAction = (message: string) => (
  alertError({summary: `Внутренняя ошибка сервера`, detail: message, sticky: true}))
export const alertLoadError: (detail: any) => AlertAction = (detail: string) =>
  alertError({summary: `Загрузка`, detail: detail + ``, sticky: true});
export const alertRequestError: () => AlertAction = () =>
  alertError({summary: `Ошибка сети`, detail: `Нет ответа от сервера`, sticky: true});

export const reducer: Reducer<AlertState> = (
  state,
  incomingAction
) => {
  if (state === undefined) {
    return {};
  }
  const action = incomingAction as unknown as AlertAction;
  const messages = action.messages;
  switch (action.type) {
    case AlertActionType.success:
      return {
        ...state,
        messages: messages.map(message => {return {...defaultMessage, ...message, severity: `success`}}) 
      };
    case AlertActionType.error:
      return {
        ...state,
        messages: messages.map(message => {return {...defaultMessage, ...message, severity: `error`}}) 
      };
    case AlertActionType.info:
      return {
        ...state,
        messages: messages.map(message => {return {...defaultMessage, ...message, severity: `info`}}) 
      };
    case AlertActionType.warn:
      return {
        ...state,
        messages: messages.map(message => {return {...defaultMessage, ...message, severity: `warn`}}) 
      };
    default:
      return state;
  }
};
